let pswpElement = null;

const gallerySelector = '.pswp-gallery';
const itemSelector = '.pswp-gallery__item';
const mediaSelector = '.pswp-gallery__media';


let initialLoad = true;
let isOpenFully = false;

let fullscreenOnOpen = false;

const closeOnBackgroundTapMobile = true;

let scrollAnimationFrame;
let scrollElement = null;

let isSwitchingGalleries = false;
let newSwitchingGalleryIndex = 0;
let newSwitchingItemIndex = 0;
let mobileTapTimer = null;
let mobileTouchStartPoint = null;
let mobileTouchDidMove = false;
const PHOTOSWIPE_DOUBLE_TAP_DELAY_MS = 300;
const MOBILE_TAP_MAX_MOVE_PX = 10;

// ============================================================================
// Debug
// ============================================================================

const debugLogConfig = {
  Event:               { enabled: false, color: 'color: #9fbbe0' }, // blue (50% white)
  Content:             { enabled: false, color: 'color: #ffbf80' }, // orange (50% white)
  PointerGesture:      { enabled: false, color: 'color: #96d896' }, // green (50% white)
  EventDocumentWindow: { enabled: false, color: 'color: #eb9393' }, // red (50% white)
  Scroll:              { enabled: true, color: 'color: #c8a8e0' }, // purple (50% white)
  Caption:             { enabled: false, color: 'color: #c5aaa2' }, // brown (50% white)
  Fullscreen:          { enabled: false, color: 'color: #f1b9d6' }, // pink (50% white)
  Share:               { enabled: false, color: 'color: #8bf1f1' }, // cyan (50% white)
  URL:                 { enabled: false, color: 'color: #d6d859' }, // yellow-green (50% white)
  Blur:                { enabled: true, color: 'color: #9fbf9f' }, // greenish (50% white)
};

function debugLog(tag, ...msgs) {
  const config = debugLogConfig[tag];
  if (config && config.enabled) {
    console.log(`%c[${tag}]`, config.color, ...msgs);
  }
}

// ============================================================================
// Construct
// ============================================================================

const elementHTMLClose = '<span class="font-icon--module-photoswipe--close"></span>';
const elementHTMLArrowPrev = '<span class="font-icon--module-photoswipe--arrow-left"></span>';
const elementHTMLArrowNext = '<span class="font-icon--module-photoswipe--arrow-right"></span>';
const elementHTMLCaption = '<span class="font-icon--module-photoswipe--closed-caption-automatic"></span>';

const lightbox = new PhotoSwipeLightbox({
  gallery: gallerySelector,
  children: itemSelector,
  arrowPrevSVG: elementHTMLArrowPrev,
  arrowNextSVG: elementHTMLArrowNext,
  closeSVG: elementHTMLClose,
  doubleTapAction: 'zoom',
  secondaryZoomLevel: (zoomLevelObject) => zoomLevelObject.fit * 2,
  maxZoomLevel: (zoomLevelObject) => zoomLevelObject.fit * 2,
  pswpModule: PhotoSwipe
});

function getVisibleMediaThumbBounds(mediaElement) {
  if (!(mediaElement instanceof HTMLElement)) {
    return null;
  }

  const rect = mediaElement.getBoundingClientRect();
  if (!(rect.width > 0 && rect.height > 0)) {
    return null;
  }

  const style = window.getComputedStyle(mediaElement);
  const objectFit = style.objectFit || 'fill';

  let naturalWidth = 0;
  let naturalHeight = 0;

  if (mediaElement instanceof HTMLImageElement) {
    naturalWidth = mediaElement.naturalWidth;
    naturalHeight = mediaElement.naturalHeight;
  } else if (mediaElement instanceof HTMLVideoElement) {
    naturalWidth = mediaElement.videoWidth;
    naturalHeight = mediaElement.videoHeight;
  }

  if (
    (objectFit !== 'contain' && objectFit !== 'scale-down') ||
    !(naturalWidth > 0 && naturalHeight > 0)
  ) {
    return { x: rect.left, y: rect.top, w: rect.width };
  }

  const mediaRatio = naturalWidth / naturalHeight;
  const frameRatio = rect.width / rect.height;

  let x = rect.left;
  let y = rect.top;
  let width = rect.width;
  let height = rect.height;

  if (mediaRatio > frameRatio) {
    height = rect.width / mediaRatio;
    y += (rect.height - height) * 0.5;
  } else {
    width = rect.height * mediaRatio;
    x += (rect.width - width) * 0.5;
  }

  return { x, y, w: width };
}

function getGalleryMediaThumbBounds(itemData) {
  const element = itemData?.element;
  if (!(element instanceof Element)) {
    return null;
  }

  const mediaElement = element.matches(mediaSelector)
    ? element
    : element.querySelector(mediaSelector);

  return getVisibleMediaThumbBounds(mediaElement);
}

lightbox.addFilter('thumbBounds', (thumbBounds, itemData) => {
  return getGalleryMediaThumbBounds(itemData) || thumbBounds;
});

function isValidLightbox() {
  return lightbox && lightbox.pswp;
}

function isTouchLikeActionEvent(event) {
  if (!event) {
    return false;
  }

  const pointerType = event.pointerType;
  if (pointerType === 'touch') {
    return true;
  }

  const type = event.type || '';
  return type.startsWith('touch');
}

function isTapOutsideCurrentSlideContent(point) {
  if (!isValidLightbox()) {
    return false;
  }

  const x = point?.x;
  const y = point?.y;
  if (typeof x !== 'number' || typeof y !== 'number') {
    return false;
  }

  const contentElement = lightbox.pswp.currSlide?.content?.element;
  if (!(contentElement instanceof Element)) {
    return false;
  }

  const rect = contentElement.getBoundingClientRect();
  return x < rect.left || x > rect.right || y < rect.top || y > rect.bottom;
}

function clearMobileTapTimer() {
  if (!mobileTapTimer) {
    return;
  }

  clearTimeout(mobileTapTimer);
  mobileTapTimer = null;
}

function resetMobileTouchTracking() {
  mobileTouchStartPoint = null;
  mobileTouchDidMove = false;
}

function handleMobileTouchStart(event) {
  if (!isValidLightbox()) {
    return;
  }

  if (event.touches?.length > 1) {
    mobileTouchDidMove = true;
    clearMobileTapTimer();
    return;
  }

  const touch = event.touches?.[0];
  if (!touch) {
    return;
  }

  mobileTouchStartPoint = { x: touch.clientX, y: touch.clientY };
  mobileTouchDidMove = false;
}

function handleMobileTouchMove(event) {
  if (!isValidLightbox()) {
    return;
  }

  if (event.touches?.length > 1) {
    toggleMenuShare(false);
    mobileTouchDidMove = true;
    clearMobileTapTimer();
    return;
  }

  if (!mobileTouchStartPoint) {
    return;
  }

  const touch = event.touches?.[0];
  if (!touch) {
    return;
  }

  const deltaX = touch.clientX - mobileTouchStartPoint.x;
  const deltaY = touch.clientY - mobileTouchStartPoint.y;
  const distance = Math.hypot(deltaX, deltaY);

  if (distance > MOBILE_TAP_MAX_MOVE_PX) {
    // Treat any meaningful touch movement as a swipe/pan interaction.
    toggleMenuShare(false);
    mobileTouchDidMove = true;
    clearMobileTapTimer();
  }
}

function handleMobileTouchCancel() {
  if (!isValidLightbox()) {
    return;
  }

  clearMobileTapTimer();
  resetMobileTouchTracking();
}

function isTapOnOverlayUI(target) {
  return target instanceof Element && !!target.closest('.pswp__button, .pswp__counter, .pswp__custom-caption, .pswp__menu');
}

function toggleOverlayUIInstant() {
  if (!isValidLightbox()) {
    return;
  }

  const element = lightbox.pswp.element;
  if (!(element instanceof Element)) {
    return;
  }

  element.classList.toggle('pswp--ui-visible');
  toggleMenuShare(false);
}

function scheduleOverlayToggle() {
  if (mobileTapTimer) {
    clearMobileTapTimer();
    return;
  }

  const mobileTapDelay = getMobileSingleTapDelay();

  mobileTapTimer = setTimeout(() => {
    toggleOverlayUIInstant();
    mobileTapTimer = null;
  }, mobileTapDelay);
}

function getMobileSingleTapDelay() {
  if (!isValidLightbox()) {
    return PHOTOSWIPE_DOUBLE_TAP_DELAY_MS;
  }

  // Matches PhotoSwipe gestures internal delay: options.doubleTapAction ? 300 : 0.
  return lightbox.pswp.options.doubleTapAction ? PHOTOSWIPE_DOUBLE_TAP_DELAY_MS : 0;
}

function closeLightboxFromTap() {
  if (!isValidLightbox()) {
    return;
  }

  clearMobileTapTimer();
  toggleMenuShare(false);
  lightbox.pswp.close();
}

function handleMobileTouchEnd(event) {
  if (!isValidLightbox()) {
    return;
  }

  if (mobileTouchDidMove) {
    clearMobileTapTimer();
    resetMobileTouchTracking();
    return;
  }

  const target = event.target;
  if (isTapOnOverlayUI(target)) {
    resetMobileTouchTracking();
    return;
  }

  const touch = event.changedTouches?.[0];
  if (!touch) {
    resetMobileTouchTracking();
    return;
  }

  const point = { x: touch.clientX, y: touch.clientY };
  const isOutsideContent = isTapOutsideCurrentSlideContent(point);
  const isBackgroundTap = target instanceof Element && !!target.closest('.pswp__bg');

  if ((closeOnBackgroundTapMobile && isOutsideContent) || isBackgroundTap) {
    event.preventDefault();
    event.stopPropagation();
    closeLightboxFromTap();
    resetMobileTouchTracking();
    return;
  }

  scheduleOverlayToggle();
  resetMobileTouchTracking();
}

// ============================================================================
// Open
// ============================================================================

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function openGalleryItemIndexes(galleryIndex, itemIndex) {
  debugLog('URL', 'openGalleryItemIndexes, galleryIndex:', galleryIndex, ', itemIndex:', itemIndex);

  const galleryElements = document.querySelectorAll(gallerySelector);

  const galleryElement = galleryElements[galleryIndex];

  lightbox.loadAndOpen(itemIndex, { gallery: galleryElement });
}

// ============================================================================
// URL
// ============================================================================

function updateURL(galleryIndex, itemIndex) {
  debugLog('URL', 'updateURL, galleryIndex:', galleryIndex, ', itemIndex:', itemIndex);

  const newURL = `${window.location.origin}${window.location.pathname}#&gallery=${galleryIndex}&item=${itemIndex}`;
  window.history.replaceState({ path: newURL }, '', newURL);
}

function updateURLWithoutGalleryItem() {
  debugLog('URL', 'updateURLWithoutGalleryItem');

  const newURL = window.location.origin + window.location.pathname;
  window.history.replaceState({ path: newURL }, '', newURL);
}

function photoswipeParseHash() {
  debugLog('URL', 'photoswipeParseHash');

  const hash = window.location.hash.substring(1);
  const params = {};

  if (hash.length < 5) {
    return { gallery: false, item: false };
  }

  const vars = hash.split('&');
  for (let i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }

    const pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }

    params[pair[0]] = pair[1];
  }

  if ('gallery' in params || 'item' in params) {
    params.gallery = parseInt(params.gallery, 10) || 1;
    params.item = parseInt(params.item, 10) || 1;
    return params;
  }

  return { gallery: false, item: false };
}

function openGalleryFromHash() {
  debugLog('URL', 'openGalleryFromHash');

  const hashData = photoswipeParseHash();

  if (!(hashData.gallery && hashData.item)) {
    initialLoad = false;
    return;
  }

  const galleryElements = document.querySelectorAll(gallerySelector);
  let galleryIndex = (hashData.gallery && hashData.gallery - 1) || 0;
  let itemIndex = (hashData.item && hashData.item - 1) || 0;

  galleryIndex = clamp(galleryIndex, 0, galleryElements.length - 1);

  const galleryElement = galleryElements[galleryIndex];
  const itemElements = galleryElement.querySelectorAll(itemSelector);
  itemIndex = clamp(itemIndex, 0, itemElements.length - 1);

  if (lightbox.pswp) {
    const currentGalleryElement = lightbox.pswp.options.dataSource.gallery;
    const currentItemIndex = lightbox.pswp.currIndex;

    if (currentGalleryElement !== galleryElement) {
      isSwitchingGalleries = true;
      newSwitchingGalleryIndex = galleryIndex;
      newSwitchingItemIndex = itemIndex;
      lightbox.pswp.close();
    } else if (currentItemIndex !== itemIndex) {
      lightbox.pswp.goTo(itemIndex);
    }
  } else {
    openGalleryItemIndexes(galleryIndex, itemIndex);
  }
}

// ============================================================================
// Scroll to Element
// ============================================================================

function getViewportHeight() {
  debugLog('Scroll', 'getViewportHeight');

  return window.innerHeight || document.documentElement.clientHeight;
}

function getViewportWidth() {
  debugLog('Scroll', 'getViewportWidth');

  return window.innerWidth || document.documentElement.clientWidth;
}

function getWindowScrollPosition() {
  debugLog('Scroll', 'getWindowScrollPosition');

  return {
    x: window.scrollX || window.pageXOffset,
    y: window.scrollY || window.pageYOffset
  };
}

function getCurrentItem() {
  debugLog('Scroll', 'getCurrentItem');

  if (!isValidLightbox()) {
    return null;
  }

  const currSlide = lightbox.pswp.currSlide;

  if (!currSlide || !currSlide.data) return null;

  // Scroll the element into view if it is off-screen
  return currSlide.data.element;
}

function getScrollElement() {
  debugLog('Scroll', 'getScrollElement');

  let currentItem = getCurrentItem();

  if (!currentItem) {
    return null;
  }

  // Check if the element's parent is a figure with a figcaption child
  if (currentItem.parentNode.tagName.toLowerCase() === 'figure' && currentItem.parentNode.querySelector('figcaption')) {
    currentItem = currentItem.parentNode;
  }

  return currentItem;
}

function getScrollElementPositionY() {
  debugLog('Scroll', 'getScrollElementPositionY');

  const elementRect = scrollElement.getBoundingClientRect();
  const viewportScrollPosition = getWindowScrollPosition().y;
  const viewportHeight = getViewportHeight();

  // Calculate the target scroll position to center the element vertically
  let targetScrollPosition = viewportScrollPosition;

  if (elementRect.top < 0 || elementRect.bottom > viewportHeight) {
    // Center the element vertically in the viewport
    targetScrollPosition = viewportScrollPosition + elementRect.top - (viewportHeight / 2 - elementRect.height / 2);
  }

  debugLog('Scroll', 'getScrollElementPositionY, targetScrollPosition:', targetScrollPosition);

  return targetScrollPosition;
}

function scrollToScrollElement(duration) {
  debugLog('Scroll', 'scrollToScrollElement, duration: ', duration);

  const startPosition = getWindowScrollPosition().y;
  const targetPosition = getScrollElementPositionY();

  debugLog('Scroll', 'scrollToScrollElement, startPosition: ', startPosition);
  debugLog('Scroll', 'scrollToScrollElement, targetPosition: ', targetPosition);

  if (startPosition == targetPosition) {
    return;
  }

  if (duration === 0) {
    window.scrollTo(0, targetPosition); // Scroll immediately
    return;
  }

  if (typeof duration !== 'number' || duration < 0) {
    duration = lightbox.pswp.options.showAnimationDuration;
  }

  const distance = targetPosition - startPosition;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;

    const timeElapsed = currentTime - startTime;
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);

    window.scrollTo(0, run);

    if (timeElapsed < duration) {
      scrollAnimationFrame = requestAnimationFrame(animation);
    }
  }

  function easeInOutQuad(t, b, c, d) {
    if (d === 0) return b + c; // Immediately go to the target position if duration is 0
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  scrollAnimationFrame = requestAnimationFrame(animation);
}

function jumpToScrollElement() {
  debugLog('Scroll', 'jumpToScrollElement');

  if (scrollAnimationFrame) {
    cancelAnimationFrame(scrollAnimationFrame);
    scrollToScrollElement(0);
  }
}

// Use this function to scroll the element into view if it is off-screen
function processScrollElement() {
  scrollElement = getScrollElement();

  debugLog('Scroll', 'processScrollElement, scrollElement: ', scrollElement);

  scrollToScrollElement();
}

// ============================================================================
// Share
// ============================================================================

function updateShareMenuPos() {
  debugLog('Share', 'updateShareMenuPos');

  const button = document.getElementById('pswp__button--share');
  const menu = document.getElementById('pswp__menu--share');

  if (!(button && menu)) {
    return;
  }

  const parent = menu.offsetParent;
  if (!(parent instanceof HTMLElement)) {
    return;
  }

  const menuStyle = window.getComputedStyle(menu);
  const marginLeft = parseFloat(menuStyle.getPropertyValue('margin-left')) || 0;
  const marginRight = parseFloat(menuStyle.getPropertyValue('margin-right')) || 0;
  const parentRect = parent.getBoundingClientRect();
  const buttonRect = button.getBoundingClientRect();
  const parentWidth = parent.clientWidth;
  let menuX = buttonRect.left - parentRect.left + buttonRect.width / 2 - menu.offsetWidth / 2;
  const menuY = buttonRect.bottom - parentRect.top;

  if (menuX < marginLeft) {
    menuX = marginLeft;
  } else if (menuX + menu.offsetWidth + marginRight > parentWidth) {
    menuX = parentWidth - menu.offsetWidth - marginRight;
  }

  menu.style.left = `${menuX - marginLeft}px`;
  menu.style.top = `${menuY}px`;
}

function toggleMenuShare(enable = true) {
  debugLog('Share', 'toggleMenuShare, enable:', enable);

  const button = document.getElementById('pswp__button--share');
  const menu = document.getElementById('pswp__menu--share');

  if (!(button && menu)) {
    return;
  }

  if (enable) {
    button.classList.add('pswp__button--open');
    if (!menu.classList.contains('pswp__menu--open')) {
      menu.classList.add('pswp__menu--open');
      updateShareMenuPos();
    }
    return;
  }

  button.classList.remove('pswp__button--open');
  menu.classList.remove('pswp__menu--open');
}

function toggleShare(event) {
  debugLog('Share', 'toggleShare');

  event.stopPropagation();

  const menu = document.getElementById('pswp__menu--share');
  if (!menu) {
    return;
  }

  toggleMenuShare(!menu.classList.contains('pswp__menu--open'));
  updateShareMenuPos();
}

function closeShareOnOutsideClick(event) {
  const menu = document.getElementById('pswp__menu--share');
  if (!menu || !menu.classList.contains('pswp__menu--open')) {
    return;
  }

  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }

  if (target.closest('#pswp__menu--share')) {
    return;
  }

  if (target.closest('#pswp__button--share')) {
    return;
  }

  toggleMenuShare(false);
}

function closeShareOnOutsideTouchStart(event) {
  const menu = document.getElementById('pswp__menu--share');
  if (!menu || !menu.classList.contains('pswp__menu--open')) {
    return;
  }

  const target = event.target;
  if (!(target instanceof Element)) {
    return;
  }

  if (target.closest('#pswp__menu--share')) {
    return;
  }

  if (target.closest('#pswp__button--share')) {
    return;
  }

  toggleMenuShare(false);
}

let shareDismissPointerStart = null;
const SHARE_DISMISS_MOVE_PX = MOBILE_TAP_MAX_MOVE_PX;

function handleShareDismissPointerDown(event) {
  const menu = document.getElementById('pswp__menu--share');
  if (!menu || !menu.classList.contains('pswp__menu--open')) {
    shareDismissPointerStart = null;
    return;
  }

  const target = event.target;
  if (!(target instanceof Element)) {
    shareDismissPointerStart = null;
    return;
  }

  if (target.closest('#pswp__menu--share') || target.closest('#pswp__button--share')) {
    shareDismissPointerStart = null;
    return;
  }

  shareDismissPointerStart = {
    pointerId: event.pointerId,
    x: event.clientX,
    y: event.clientY
  };
}

function handleShareDismissPointerMove(event) {
  if (!shareDismissPointerStart) {
    return;
  }

  if (event.pointerId !== shareDismissPointerStart.pointerId) {
    return;
  }

  const dx = event.clientX - shareDismissPointerStart.x;
  const dy = event.clientY - shareDismissPointerStart.y;
  const distance = Math.hypot(dx, dy);

  if (distance > SHARE_DISMISS_MOVE_PX) {
    toggleMenuShare(false);
    shareDismissPointerStart = null;
  }
}

function handleShareDismissPointerEnd(event) {
  if (!shareDismissPointerStart) {
    return;
  }

  if (event.pointerId === shareDismissPointerStart.pointerId) {
    shareDismissPointerStart = null;
  }
}

let copyUrlTimer = null;
const copyUrlText = '<span class="font-icon--module-photoswipe--copy"></span> Copy URL';

function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise((resolve, reject) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'absolute';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
      resolve();
    } catch (error) {
      reject(error);
    } finally {
      document.body.removeChild(textArea);
    }
  });
}

function copyUrl(event) {
  debugLog('Share', 'copyUrl, copyUrlTimer:', copyUrlTimer);

  event.preventDefault();

  const button = event.currentTarget;

  copyTextToClipboard(window.location.href).then(() => {
    if (copyUrlTimer) {
      clearTimeout(copyUrlTimer);
    } else {
      button.innerHTML = '<span class="font-icon--module-photoswipe--copy"></span> Copied!';
      updateShareMenuPos();
    }

    copyUrlTimer = setTimeout(() => {
      button.innerHTML = copyUrlText;
      updateShareMenuPos();
      copyUrlTimer = null;
    }, 3000);
  }).catch((error) => {
    console.error('Failed to copy share URL', error);
  });
}

function downloadImage(event) {
  debugLog('Share', 'downloadImage');

  event.preventDefault();

  const slideData = lightbox.pswp?.currSlide?.data;
  const url = slideData?.src;
  if (!url) {
    return;
  }

  fetch(url).then((response) => response.blob()).then((blob) => {
    const anchor = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);

    anchor.href = objectUrl;
    anchor.download = url.split('/').pop() || 'download';
    document.body.appendChild(anchor);
    anchor.click();
    URL.revokeObjectURL(objectUrl);
    document.body.removeChild(anchor);
  }).catch((error) => {
    console.error('Failed to download image', error);
  });
}

// ============================================================================
// Fullscreen
// ============================================================================

// Function to check if we are in fullscreen mode
function isFullscreen() {
  debugLog('Fullscreen', 'debugLog_Fullscreen');

  return !!getFullscreenElement();
}

function getFullscreenElement() {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement ||
    null
  );
}

function getFullscreenTargetElement() {
  return document.documentElement;
}

// Function to check if fullscreen is supported
function isFullscreenSupported() {
  debugLog('Fullscreen', 'isFullscreenSupported');

  return !!(
    document.fullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.msFullscreenEnabled
  );
}

// Function to update fullscreen button content
function updateFullscreenButton(isFullscreen) {
  debugLog('Fullscreen', 'updateFullscreenButton, isFullscreen:', isFullscreen);

  const fullscreenActive = typeof isFullscreen === 'boolean' ? isFullscreen : !!getFullscreenElement();
  const button = document.querySelector('.pswp__button--fs');
  if (button) {
    if (fullscreenActive) {
      button.innerHTML = '<span class="font-icon--module-photoswipe--fullscreen-disable"></span>';
      button.title = 'Exit fullscreen';
      button.setAttribute('aria-label', 'Exit fullscreen');
    } else {
      button.innerHTML = '<span class="font-icon--module-photoswipe--fullscreen-enable"></span>';
      button.title = 'Fullscreen';
      button.setAttribute('aria-label', 'Fullscreen');
    }
  }
}

// Function to request fullscreen mode
function enterFullscreen() {
  debugLog('Fullscreen', 'enterFullscreen');

  const elem = getFullscreenTargetElement();
  const requestFullscreen = (
    elem.requestFullscreen ||
    elem.mozRequestFullScreen ||
    elem.webkitRequestFullscreen ||
    elem.msRequestFullscreen
  );

  if (!requestFullscreen) {
    return;
  }

  const fullscreenResult = requestFullscreen.call(elem);

  if (fullscreenResult?.catch) {
    fullscreenResult
      .then(() => updateFullscreenButton())
      .catch((error) => {
        console.error('Failed to enter fullscreen', error);
        updateFullscreenButton(false);
      });
  } else {
    updateFullscreenButton(true);
  }
}

// Function to exit fullscreen mode
function exitFullscreen() {
  debugLog('Fullscreen', 'exitFullscreen');

  const exitFullscreen = (
    document.exitFullscreen ||
    document.mozCancelFullScreen ||
    document.webkitExitFullscreen ||
    document.msExitFullscreen
  );

  if (!exitFullscreen) {
    return;
  }

  const fullscreenResult = exitFullscreen.call(document);

  if (fullscreenResult?.catch) {
    fullscreenResult
      .then(() => updateFullscreenButton())
      .catch((error) => {
        console.error('Failed to exit fullscreen', error);
        updateFullscreenButton();
      });
  } else {
    updateFullscreenButton(false);
  }
}

// Function to toggle fullscreen mode
function toggleFullscreen() {
  debugLog('Fullscreen', 'toggleFullscreen');

  if (!isFullscreen()) {
    enterFullscreen();
  } else {
    exitFullscreen();
  }
}

document.addEventListener('fullscreenchange', () => updateFullscreenButton());
document.addEventListener('mozfullscreenchange', () => updateFullscreenButton());
document.addEventListener('webkitfullscreenchange', () => updateFullscreenButton());
document.addEventListener('MSFullscreenChange', () => updateFullscreenButton());

if (isFullscreenSupported()) {
  lightbox.on('uiRegister', function() {
    debugLog('Fullscreen', 'uiRegister pswp__button--fs');

    lightbox.pswp.ui.registerElement({
      name: 'fullscreen-button',
      order: 8,
      isButton: true,
      tagName: 'button',
      html: '<span class="font-icon--module-photoswipe--fullscreen-enable"></span>',
      title: 'Fullscreen',
      className: 'pswp__button--fs',
      onClick: toggleFullscreen
    });
  });
}

lightbox.on('uiRegister', function() {
  debugLog('Share', 'uiRegister pswp__button--share');

  lightbox.pswp.ui.registerElement({
    name: 'share-button',
    order: 8,
    isButton: true,
    tagName: 'button',
    html: '<span class="font-icon--module-photoswipe--share"></span>',
    title: 'Share',
    className: 'pswp__button--share',
    onClick: toggleShare,
    onInit: (el) => {
      el.id = 'pswp__button--share';
    }
  });
});

lightbox.on('uiRegister', function() {
  debugLog('Share', 'uiRegister pswp__menu--share');

  lightbox.pswp.ui.registerElement({
    name: 'share-menu',
    order: 7,
    isButton: false,
    tagName: 'div',
    html: `
      <a id="copy-url" class="pswp__button button" href="#" rel="noopener" title="Copy the current gallery URL" aria-label="Copy the current gallery URL">${copyUrlText}</a>
      <a id="download-image" class="pswp__button button" href="#" rel="noopener" title="Download the current image" aria-label="Download the current image"><span class="font-icon--module-photoswipe--download"></span> Download Image</a>
    `,
    className: 'pswp__menu pswp__menu--share',
    onInit: (el, pswp) => {
      el.id = 'pswp__menu--share';

      pswp.on('change', () => {
        const downloadButton = document.getElementById('download-image');
        const slideData = pswp.currSlide?.data;
        const src = slideData?.src?.toLowerCase() || '';
        const isImage = ['.jpeg', '.jpg', '.gif', '.png', '.bmp', '.webp', '.svg'].some((ext) => src.endsWith(ext));

        if (!downloadButton) {
          return;
        }

        const previousDisplay = downloadButton.style.display;
        downloadButton.style.display = isImage ? 'block' : 'none';

        if (downloadButton.style.display !== previousDisplay) {
          updateShareMenuPos();
        }
      });
    }
  });
});

// ============================================================================
// Zoom Indicator
// ============================================================================

// lightbox.on('uiRegister', function() {
//   lightbox.pswp.ui.registerElement({
//     name: 'zoom-level-indicator',
//     order: 9,
//     onInit: (el, pswp) => {
//       pswp.on('zoomPanUpdate', (e) => {
//         if (e.slide === pswp.currSlide) {
//           el.innerHTML = '<span class="label">Zoom</span><span class="value">' + Math.ceil(pswp.currSlide.currZoomLevel * 100) + '%</span>';
//         }
//       });
//     }
//   });
// });

// ============================================================================
// Caption
// ============================================================================

const captionToggleClass = 'pswp--caption-toggle-available';
const captionHiddenClass = 'pswp--caption-hidden';
const captionOverflowViewportRatio = 0.18;
const captionOverflowImageRatio = 0.18;
const captionOverflowMaxHeight = 160;
const captionModeAutomatic = 'automatic';
const captionModeOn = 'on';
const captionModeOff = 'off';
const captionModeOrder = [captionModeAutomatic, captionModeOn, captionModeOff];
const captionModeIconClasses = {
  [captionModeAutomatic]: 'font-icon--module-photoswipe--closed-caption-automatic',
  [captionModeOn]: 'font-icon--module-photoswipe--closed-caption-on',
  [captionModeOff]: 'font-icon--module-photoswipe--closed-caption-off'
};
const captionModeLabels = {
  [captionModeAutomatic]: 'Caption mode: automatic. Switch captions on.',
  [captionModeOn]: 'Caption mode: on. Switch captions off.',
  [captionModeOff]: 'Caption mode: off. Switch captions to automatic.'
};

let captionElement = null;
let captionMeasureElement = null;
let captionToggleButton = null;
let captionHasContent = false;
let captionHidden = false;
let captionMode = captionModeAutomatic;
let captionTooTall = false;
let captionMeasureFrame = null;
let captionPendingCommitId = 0;

function getCurrentPswpImageElement() {
  if (!isValidLightbox()) {
    return null;
  }

  const currentSlide = lightbox.pswp.currSlide;
  const contentElement = currentSlide?.content?.element;

  if (contentElement instanceof HTMLImageElement) {
    return contentElement;
  }

  if (contentElement instanceof Element) {
    const contentImage = contentElement.querySelector('.pswp__img');
    if (contentImage instanceof HTMLImageElement) {
      return contentImage;
    }
  }

  const currentItem = lightbox.pswp.element?.querySelector('.pswp__item[aria-hidden="false"] .pswp__img');
  return currentItem instanceof HTMLImageElement ? currentItem : null;
}

function updateCaptionToggleButton() {
  if (!captionToggleButton) {
    return;
  }

  const label = captionModeLabels[captionMode] || captionModeLabels[captionModeAutomatic];
  const iconElement = captionToggleButton.querySelector('span');

  if (iconElement) {
    iconElement.className = captionModeIconClasses[captionMode] || captionModeIconClasses[captionModeAutomatic];
  }

  captionToggleButton.dataset.captionMode = captionMode;
  captionToggleButton.title = label;
  captionToggleButton.setAttribute('aria-label', label);
  captionToggleButton.removeAttribute('aria-pressed');
}

function applyCaptionState() {
  if (!isValidLightbox()) {
    return;
  }

  const root = lightbox.pswp.element;
  root.classList.toggle(captionToggleClass, captionHasContent);
  root.classList.toggle(captionHiddenClass, captionHidden);
  updateCaptionToggleButton();
}

function applyCaptionModeState() {
  if (!captionHasContent) {
    captionHidden = false;
  } else if (captionMode === captionModeOn) {
    captionHidden = false;
  } else if (captionMode === captionModeOff) {
    captionHidden = true;
  } else {
    captionHidden = captionTooTall;
  }

  applyCaptionState();
}

function escapeCaptionHTML(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildCaptionHTML(captionText, sourceURL, sourceLabel) {
  const parts = [];

  if (captionText) {
    parts.push(escapeCaptionHTML(captionText));
  }

  if (sourceURL) {
    parts.push(
      `<a class="gallery-source" href="${escapeCaptionHTML(sourceURL)}" target="_blank" rel="noopener noreferrer">${escapeCaptionHTML(sourceLabel || 'Source')} <span class="font-icon--interface--external"></span></a>`
    );
  }

  return parts.join(' ');
}

function getSlideCaptionHTML(currSlideElement) {
  if (!currSlideElement) {
    return '';
  }

  const captionHTML = currSlideElement.getAttribute('data-caption-html');
  if (captionHTML) {
    return captionHTML;
  }

  const dataCaption = currSlideElement.getAttribute('data-caption');
  const dataSourceURL = currSlideElement.getAttribute('data-source-url');
  const dataSourceLabel = currSlideElement.getAttribute('data-source-label') || 'Source';

  if (dataCaption || dataSourceURL) {
    return buildCaptionHTML(dataCaption, dataSourceURL, dataSourceLabel);
  }

  const parentElement = currSlideElement.parentElement;
  let captionElement = null;

  if (parentElement && parentElement.tagName.toLowerCase() === 'figure') {
    captionElement = parentElement.querySelector('figcaption');
  }

  if (captionElement) {
    return captionElement.innerHTML;
  }

  return currSlideElement.querySelector('img')?.getAttribute('alt') || '';
}

function commitCaptionHTML(captionHTML, tooTall) {
  if (!(captionElement instanceof HTMLElement)) {
    return;
  }

  captionTooTall = !!tooTall;
  captionHasContent = !!captionHTML;

  if (captionHasContent) {
    captionElement.innerHTML = captionHTML;
    captionElement.style.display = 'block';
  } else {
    captionElement.innerHTML = '';
    captionElement.style.display = 'none';
  }

  applyCaptionModeState();
}

function cycleCaptionMode() {
  if (!captionHasContent) {
    return;
  }

  const currentModeIndex = captionModeOrder.indexOf(captionMode);
  const nextModeIndex = currentModeIndex < 0 ? 0 : (currentModeIndex + 1) % captionModeOrder.length;
  captionMode = captionModeOrder[nextModeIndex];

  if (captionMode === captionModeAutomatic) {
    scheduleCaptionOverflowMeasure();
  } else {
    applyCaptionModeState();
  }
}

function measureCaptionHTMLOverflow(captionHTML) {
  if (!isValidLightbox() || !(captionMeasureElement instanceof HTMLElement) || !captionHTML) {
    return false;
  }

  captionMeasureElement.innerHTML = captionHTML;
  const captionRect = captionMeasureElement.getBoundingClientRect();
  const viewportHeight = getViewportHeight();
  const imageElement = getCurrentPswpImageElement();
  const imageRect = imageElement?.getBoundingClientRect();
  const viewportThreshold = Math.min(captionOverflowMaxHeight, viewportHeight * captionOverflowViewportRatio);
  let overlapsImageTooMuch = false;

  if (imageRect && imageRect.height > 0) {
    const overlapHeight = Math.max(0, imageRect.bottom - captionRect.top);
    overlapsImageTooMuch = overlapHeight > imageRect.height * captionOverflowImageRatio;
  }

  return captionRect.height > viewportThreshold || overlapsImageTooMuch;
}

function scheduleCaptionCommit(captionHTML) {
  if (captionMode !== captionModeAutomatic) {
    commitCaptionHTML(captionHTML, captionMode === captionModeOff);
    return;
  }

  if (captionMeasureFrame) {
    window.cancelAnimationFrame(captionMeasureFrame);
  }

  const commitId = ++captionPendingCommitId;

  captionMeasureFrame = window.requestAnimationFrame(() => {
    captionMeasureFrame = window.requestAnimationFrame(() => {
      captionMeasureFrame = null;

      if (commitId !== captionPendingCommitId) {
        return;
      }

      commitCaptionHTML(captionHTML, measureCaptionHTMLOverflow(captionHTML));
    });
  });
}

function scheduleCaptionOverflowMeasure() {
  if (!(captionElement instanceof HTMLElement)) {
    return;
  }

  scheduleCaptionCommit(captionElement.style.display === 'none' ? '' : captionElement.innerHTML);
}

lightbox.on('uiRegister', function() {
  debugLog('Caption', 'uiRegister caption-toggle');

  lightbox.pswp.ui.registerElement({
    name: 'caption-toggle',
    order: 7.95,
    isButton: true,
    tagName: 'button',
    appendTo: 'bar',
    html: elementHTMLCaption,
    title: captionModeLabels[captionModeAutomatic],
    className: 'pswp__button--caption-toggle',
    onClick: cycleCaptionMode,
    onInit: (el) => {
      captionToggleButton = el;
      updateCaptionToggleButton();
    }
  });
});

lightbox.on('uiRegister', function() {
  debugLog('Caption', 'uiRegister custom-caption');

  lightbox.pswp.ui.registerElement({
    name: 'custom-caption',
    order: 9,
    isButton: false,
    appendTo: 'root',
    html: 'Caption text',
    onInit: (el, pswp) => {
      captionElement = el;
      captionMeasureElement = document.createElement('div');
      captionMeasureElement.className = 'pswp__custom-caption pswp__custom-caption--measure';
      captionMeasureElement.setAttribute('aria-hidden', 'true');
      lightbox.pswp.element.appendChild(captionMeasureElement);

      lightbox.pswp.on('change', () => {
        debugLog('Caption', 'custom-caption change');

        const currSlideElement = lightbox.pswp.currSlide.data.element;
        const captionHTML = getSlideCaptionHTML(currSlideElement);
        scheduleCaptionCommit(captionHTML);
      });
    }
  });
});

// ============================================================================
// Idle Fade - Desktop
// ============================================================================

let mouseTimer;
let menuShareHideTimer = null;
const fadeDuration = 3000; // milliseconds
const menuShareHideDelay = 2000; // milliseconds

let mouseOverUICount = 0;

function isIdleAllowed() {
  return isOpenFully && !mouseOverUICount;
}

// Function to handle mouse movements and interactions
function handleInteraction() {
  // console.log('Interaction detected. Showing UI...');

  showUI();

  if (!isIdleAllowed()) {
    return;
  }

  mouseTimer = setTimeout(hideUI, fadeDuration);
}

// Function to show the UI elements
function showUI() {
  // console.log('Showing UI elements...');

  clearTimeout(mouseTimer);
  if (menuShareHideTimer) {
    clearTimeout(menuShareHideTimer);
    menuShareHideTimer = null;
  }

  if (!pswpElement) {
    return;
  }

  pswpElement.classList.remove('idle-fade');
}

// Function to hide the UI elements
function hideUI() {
  // console.log('Hiding UI elements...');

  if (!pswpElement) {
    return;
  }

  pswpElement.classList.add('idle-fade');
  if (menuShareHideTimer) {
    clearTimeout(menuShareHideTimer);
  }
  menuShareHideTimer = setTimeout(() => {
    toggleMenuShare(false);
    menuShareHideTimer = null;
  }, menuShareHideDelay);
}

function isDesktop() {
  return !('ontouchstart' in window || navigator.maxTouchPoints);
}

// function isDesktop() {
//   const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
//   const userAgent = navigator.userAgent || navigator.vendor || window.opera;
//   const isAndroid = /android/i.test(userAgent);
//   const isMobile = /mobile/i.test(userAgent);

//   // Return true if the device is not touch-capable or it's not an Android/mobile device
//   return !hasTouch && !isAndroid && !isMobile;
// }

// Add event listeners for user interactions
if (isDesktop()) {
  document.addEventListener('mousemove', handleInteraction);
  document.addEventListener('click', handleInteraction);

  // Focus
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      return;
    }

    if (!document.body.classList.contains('input-keyboard-navigation')) {
      return;
    }

    document.dispatchEvent(new CustomEvent('input_navigation_mouse'));
    handleInteraction();
  });

  // purposefully avoiding keyboard to allow ui-less presentations.

  // document.addEventListener('keydown', handleInteraction);
  // document.addEventListener('keyup', handleInteraction);

  // purposefully avoiding touch as touch is already handled by PhotoSwipe.

  // document.addEventListener('touchstart', handleInteraction);
  // document.addEventListener('touchmove', handleInteraction);
  // document.addEventListener('touchend', handleInteraction);
}

// ============================================================================
// Google Map
// ============================================================================

// parse data-google-map-url attribute
lightbox.addFilter('itemData', (itemData, index) => {

  const el = itemData.element;

  if (!el) {
    return;
  }

  const googleMapUrl = el.dataset.googleMapUrl;
  if (googleMapUrl) {
    itemData.googleMapUrl = googleMapUrl;
  }
  return itemData;
});

// ============================================================================
// Event - Content
// ============================================================================

lightbox.on('contentLoad', (e) => {
  debugLog('Content', 'contentLoad', e);

  const { content } = e;
  if (content.type === 'google-map') {
    // prevent the default behavior
    e.preventDefault();

    // Create a container for iframe
    // and assign it to the `content.element` property
    content.element = document.createElement('div');
    content.element.className = 'pswp__google-map-container';

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = content.data.googleMapUrl;
    content.element.appendChild(iframe);
  }
});

// ============================================================================
// Blur
// ============================================================================

let supportsBackdropFilter = null;
let elementBlur = null;

function getSupportsBackdropFilter() {
  debugLog('Blur', 'getSupportsBackdropFilter');

  const element = document.createElement('div');
  element.style.cssText = 'backdrop-filter: blur(2px); -webkit-backdrop-filter: blur(2px);';

  document.body.appendChild(element);
  const computedStyle = window.getComputedStyle(element);
  const isSupported = !!computedStyle.backdropFilter ? 'backdropFilter' : !!computedStyle.webkitBackdropFilter ? 'webkitBackdropFilter' : null;

  document.body.removeChild(element);

  return isSupported;
}

function animateBlur(element, start, end, duration) {
  debugLog('Blur', 'animateBlur , element:', element, ', start:', start, ', end:', end, ', duration:', duration);

  if (duration === 0) {
    element.style[supportsBackdropFilter] = `blur(${end}px)`;
    return;
  }

  const startTime = performance.now();

  function animate(currentTime) {
    const elapsedTime = currentTime - startTime;
    const progress = Math.min(elapsedTime / duration, 1);
    const currentBlur = start + (end - start) * progress;

    element.style[supportsBackdropFilter] = `blur(${currentBlur}px)`;

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  }

  requestAnimationFrame(animate);
}

function initBlur(forcedDuration) {
  debugLog('Blur', 'initBlur');

  if (supportsBackdropFilter === null) {
    supportsBackdropFilter = getSupportsBackdropFilter();
  }

  if (!supportsBackdropFilter) {
    return;
  }

  // Step 1: Create a new element
  if (elementBlur) {
    return;
  }

  elementBlur = document.createElement('div');

  // Step 2: Set its class
  elementBlur.classList.add('pswp__bg_blur');

  // Step 3: Append it to the desired parent element
  // Assuming you want to append it to the body
  document.body.appendChild(elementBlur);

  elementBlur.style.willchange = "transform";

  // Animate blur in
  const openDuration = typeof forcedDuration === 'number'
    ? forcedDuration
    : getEffectiveTransitionDuration('showAnimationDuration');
  animateBlur(elementBlur, 0, 10, openDuration); // Adjust end blur value as needed
}

function hideBlur() {
  debugLog('Blur', 'hideBlur');

  if (elementBlur) {
    // Animate blur out
    animateBlur(elementBlur, 10, 0, getEffectiveTransitionDuration('hideAnimationDuration')); // Adjust end blur value as needed
  }
}

function destroyBlur() {
  debugLog('Blur', 'destroyBlur');

  if (elementBlur) {
    elementBlur.parentNode.removeChild(elementBlur);
    elementBlur = null;
  }
}

// ============================================================================
// Event - Open
// ============================================================================

function getAnimationDuration() {
  return 333;
}

function getEffectiveTransitionDuration(optionKey) {
  if (!isValidLightbox()) {
    return 0;
  }

  const options = lightbox.pswp.options || {};
  if (options.showHideAnimationType === 'none') {
    return 0;
  }

  // PhotoSwipe calculates the final effective open/close duration on opener.It.
  const openerDuration = lightbox.pswp.opener?.It;
  if (typeof openerDuration === 'number') {
    return openerDuration;
  }

  const configuredDuration = Number(options[optionKey]);
  if (Number.isFinite(configuredDuration) && configuredDuration > 0) {
    return configuredDuration;
  }

  return 0;
}

// photoswipe starts to open
lightbox.on('beforeOpen', () => {
  debugLog('Event', 'beforeOpen');

  lightbox.pswp.options.showAnimationDuration = getAnimationDuration();
});

// photoswipe keeps opening
// you may modify initial index or basic DOM structure
lightbox.on('firstUpdate', function() {
  debugLog('Event', 'firstUpdate');

  fullscreenOnOpen = isFullscreen();
  updateFullscreenButton(fullscreenOnOpen);

  // For zero-duration opens, initialize blur before openingAnimationStart to avoid a visible lag frame.
  if (getEffectiveTransitionDuration('showAnimationDuration') === 0) {
    initBlur(0);
  }
});

// photoswipe measures size of various elements
// if you need to read getBoundingClientRect of something - do it here
// lightbox.on('initialLayout', () => {
//   debugLog('Event', 'initialLayout');
// });

// triggers when slide is switched, and at initialization
lightbox.on('change', () => {
  debugLog('Event', 'change');

  // Update URL when slide changes
  const currSlide = lightbox.pswp.currSlide;

  if (!currSlide || !currSlide.data) return;

  const galleryElements = document.querySelectorAll(gallerySelector);
  let gallery = 0;
  for (let i = 0; i < galleryElements.length; i++) {
    if (galleryElements[i].contains(currSlide.data.element)) {
      gallery = i + 1;
      break;
    }
  }
  const item = currSlide.index + 1;

  updateURL(gallery, item);

  processScrollElement();
});

// Keep desktop native PhotoSwipe actions and suppress only touch-origin single-tap actions.
lightbox.on('tapAction', (e) => {
  if (isTouchLikeActionEvent(e.originalEvent)) {
    e.preventDefault();
  }
});

lightbox.on('imageClickAction', (e) => {
  if (isTouchLikeActionEvent(e.originalEvent)) {
    e.preventDefault();
  }
});

lightbox.on('bindEvents', () => {
  debugLog('Event', 'bindEvents');
  // photoswipe binds DOM events (such as pointer events, wheel, etc)

  // Event listeners for .pswp__button elements to track mouseover state
  document.querySelectorAll('.pswp__button, .pswp__counter, .pswp__zoom-level-indicator, .pswp__custom-caption, .pswp__menu').forEach(element => {
    element.addEventListener('mouseenter', () => {
      mouseOverUICount += 1;
      // console.log(`Mouse entered: ${element.className}, button count: ${mouseOverUICount}`);
    });
    element.addEventListener('mouseleave', () => {
      mouseOverUICount = Math.max(mouseOverUICount - 1, 0);
      // console.log(`Mouse left: ${element.className}, button count: ${mouseOverUICount}`);
    });
  });

  document.getElementById('copy-url')?.addEventListener('click', copyUrl);
  document.getElementById('download-image')?.addEventListener('click', downloadImage);

  const pswpRoot = lightbox.pswp?.element;
  if (pswpRoot) {
    pswpRoot.addEventListener('click', closeShareOnOutsideClick);
    pswpRoot.addEventListener('pointerdown', handleShareDismissPointerDown, { passive: true });
    pswpRoot.addEventListener('pointermove', handleShareDismissPointerMove, { passive: true });
    pswpRoot.addEventListener('pointerup', handleShareDismissPointerEnd, { passive: true });
    pswpRoot.addEventListener('pointercancel', handleShareDismissPointerEnd, { passive: true });
    pswpRoot.addEventListener('touchstart', closeShareOnOutsideTouchStart, { passive: true });
    pswpRoot.addEventListener('touchstart', handleMobileTouchStart, { passive: true });
    pswpRoot.addEventListener('touchmove', handleMobileTouchMove, { passive: true });
    pswpRoot.addEventListener('touchcancel', handleMobileTouchCancel, { passive: true });
    pswpRoot.addEventListener('touchend', handleMobileTouchEnd, { passive: false });
  }
});

lightbox.on('openingAnimationStart', () => {
  debugLog('Event', 'closingAnimationStart');

  isOpenFully = false;
  isSwitchingGalleries = false;

  initBlur();

  pswpElement = document.querySelector('.pswp');
  if (pswpElement) {
    pswpElement.classList.add('pswp--animation-open');
  }
});

lightbox.on('openingAnimationEnd', () => {
  debugLog('Event', 'closingAnimationEnd');

  if (pswpElement) {
    pswpElement.classList.remove('pswp--animation-open');
  }

  initialLoad = false;
  isOpenFully = true;

  if (isDesktop()) {
    handleInteraction();
  }
});

// ============================================================================
// Event - Close
// ============================================================================

// PhotoSwipe starts to close, unbind most events here
lightbox.on('close', () => {
  debugLog('Event', 'close');

  jumpToScrollElement();
});

lightbox.on('closingAnimationStart', () => {
  debugLog('Event', 'closingAnimationStart');

  isOpenFully = false;

  jumpToScrollElement();

  if (!isSwitchingGalleries) {
    updateURLWithoutGalleryItem();
  }

  if (!fullscreenOnOpen && isFullscreen()) {
    exitFullscreen();
  }

  showUI();

  if (pswpElement) {
    pswpElement.classList.add('pswp--animation-close');
  }

  hideBlur();
});

// PhotoSwipe is fully closed, destroy everything
lightbox.on('destroy', () => {
  debugLog('Event', 'destroy');

  jumpToScrollElement();
  clearMobileTapTimer();
  resetMobileTouchTracking();

  if (captionMeasureFrame) {
    window.cancelAnimationFrame(captionMeasureFrame);
    captionMeasureFrame = null;
  }

  captionPendingCommitId += 1;

  if (captionMeasureElement) {
    captionMeasureElement.remove();
  }

  captionElement = null;
  captionMeasureElement = null;
  captionToggleButton = null;
  captionHasContent = false;
  captionHidden = false;
  captionMode = captionModeAutomatic;
  captionTooTall = false;

  if (isSwitchingGalleries) {
    setTimeout(() => {
      openGalleryItemIndexes(newSwitchingGalleryIndex, newSwitchingItemIndex);
    }, 1);
  }

  destroyBlur();
});

// ============================================================================
// Events
// ============================================================================

// Focus

// triggers when slide is switched, and at initialization
// lightbox.on('change', () => {
//   debugLog('Event', 'destroy');

//   // if (!document.body.classList.contains('input-keyboard-navigation')) {
//   //   return;
//   // }

//   document.dispatchEvent(new CustomEvent('input_navigation_mouse'));
// });

lightbox.on('pointerDown', (e) => {
  debugLog('Event', 'pointerDown', e.originalEvent);

  document.dispatchEvent(new CustomEvent('input_navigation_mouse'));
});

// ============================================================================
// Init
// ============================================================================

lightbox.init();
openGalleryFromHash();

// ============================================================================
// Control
// ============================================================================

function PSWP_Open(gallery, item) {
  debugLog('URL', 'PSWP_Open, gallery:', gallery, ', item:', item);

  // Open the gallery based on the new hash
  openGalleryItemIndexes(gallery, item);
}

// ============================================================================
// Document & Window
// ============================================================================

// Function to reposition the menu on window resize
function onWindowResize() {
  debugLog('EventDocumentWindow', 'onWindowResize');

  if (!isValidLightbox()) {
    return;
  }

  updateShareMenuPos();
  scheduleCaptionOverflowMeasure();
}

// Bind the resize event to the window
window.addEventListener('resize', onWindowResize);
window.addEventListener('hashchange', openGalleryFromHash, false);
window.addEventListener('popstate', (event) => {
  debugLog('URL', 'popstate, event.state:', event.state);

  if (event.state && isValidLightbox()) {
    lightbox.pswp.close();
  }
}, false);

window.PSWP_Open = PSWP_Open;
